import PropTypes from 'prop-types';
import { TableCell, TableRow, Typography } from '@mui/material';

/** Renders a full-width empty state row inside a TableBody. */
const EmptyTableRow = ({ colSpan, message }) => (
  <TableRow>
    <TableCell
colSpan={colSpan}
align="center"
sx={{ py: 6, border: 'none' }}
    >
      <Typography
variant="body2"
color="text.secondary"
      >
        {message}
      </Typography>
    </TableCell>
  </TableRow>
);

EmptyTableRow.propTypes = {
  colSpan: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
};

export default EmptyTableRow;
